<template>
  <v-container>
    <v-card elevation="4" outlined>
      <v-card-title class="py-3 px-6">
        <span class="text-h6 font-weight-medium">Relatório de Boletim de Caixa</span>
        <v-spacer></v-spacer>
        <v-select
          outlined
          dense
          return-object
          hide-details
          label="Empresa"
          item-value="id"
          item-text="fantasyName"
          v-model="report.selectEnterprise"
          :items="enterprise"
          style="max-width: 280px"
        />
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-6 pt-6 pb-2">
        <Form :component="this" ref="form" />
        <InvalidDateDialog :component="this" v-if="invalidDateDialog" />
      </v-card-text>
      <v-card-actions class="px-6 pb-4">
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          :disabled="!valid || noCashierLinked || loading"
          :loading="loading"
          @click="validDate()"
          min-width="160"
        >
          <v-icon class="mr-2">mdi-file-chart</v-icon> Visualizar
        </v-btn>
      </v-card-actions>
    </v-card>
    <AlertAPI />
  </v-container>
</template>

<script>
import Form from "@/components/report/close_cashier/Form/index.vue";
import InvalidDateDialog from "@/views/Reports/close_cashier/invalidDateDialog.vue";
import AlertAPI from "@/components/alert_api";
import { GET_ALL_ENTERPRISE } from "@/store/actions/enterprise";
import { GET_ALL_CASHIER } from "@/store/actions/cashier";
import { GET_CASHIER_CLOSE_REPORT } from "@/store/actions/sales";
import { mapGetters } from "vuex";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { formatCurrency } from "@/utils/formatters";

export default {
  components: { Form, InvalidDateDialog, AlertAPI },

  data: () => ({
    dialog: Boolean(),
    valid: false,
    loading: false,
    userName: String(),
    enterprise: [],
    cashier: [],
    noCashierLinked: false,
    report: {
      selectEnterprise: Object(),
      selectCashier: null,
      date_initial_close_cashier: null,
      date_finish_close_cashier: null,
      generate_with_budget: false,
      filter_credit: false,
    },
    invalidDateDialog: false,
  }),

  methods: {
    validDate() {
      const currentDate = new Date();
      const year  = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day   = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      if (
        this.report.date_initial_close_cashier <= formattedDate &&
        this.report.date_finish_close_cashier  <= formattedDate &&
        this.report.date_initial_close_cashier <= this.report.date_finish_close_cashier
      ) {
        this.Generate();
      } else {
        this.invalidDateDialog = true;
      }
    },

    async Generate() {
      this.loading = true;
      try {
        const payload = {
          enterprise_id: this.report.selectEnterprise.id,
          cashier_id: this.report.selectCashier,
          date_initial_close_cashier: this.report.date_initial_close_cashier,
          date_finish_close_cashier:  this.report.date_finish_close_cashier,
          generate_with_budget: this.report.generate_with_budget ? 1 : 0,
          filter_credit:        this.report.filter_credit        ? 1 : 0,
        };

        let response = null;
        await this.$store.dispatch(GET_CASHIER_CLOSE_REPORT, payload).then((result) => {
          response = result.response;
        });

        this.dialog = !this.dialog;
        this.$refs.form.reset();
        this.$refs.form.validate();
        this.$refs.form.resetValidation();

        const arrayenterprise = [Object.assign({}, this.report.selectEnterprise)];
        const arrayaddress    = [Object.assign({}, this.report.selectEnterprise.address)];

        const toArr = (obj) => Object.keys(obj).map(k => obj[k]);

        const cashier_operation         = toArr(response.data.cashier_operation);
        const cashier_operation_history = toArr(response.data.cashier_operation_history);
        const sales_by_payment_method   = toArr(response.data.sales_by_payment_method);
        const employee_summary          = toArr(response.data.employee_summary);

        let canceled_notes   = response.data.canceled_notes   ? toArr(response.data.canceled_notes)   : null;
        let unfinished_notes = response.data.unfinished_notes ? toArr(response.data.unfinished_notes) : null;
        let canceled_items   = response.data.canceled_items   ? toArr(response.data.canceled_items)   : null;

        let total_value_form_payment = 0, total_value_movement = 0;
        let total_canceled_notes = 0, total_unfinished_notes = 0, total_canceled_items_value = 0;
        let total_employee_sales = 0, total_qty_sales = 0;

        for (const o of sales_by_payment_method) total_value_form_payment += o.value_form_payment;
        for (const o of cashier_operation)        total_value_movement     += o.value_movement;
        for (const o of employee_summary) {
          total_employee_sales += o.total_sales_value || 0;
          total_qty_sales      += parseInt(o.total_sales_count) || 0;
        }
        if (canceled_notes) for (const o of canceled_notes) total_canceled_notes += o.value_total_note || 0;

        const raw_payment = sales_by_payment_method.map(o => ({ label: o.descrition_form_of_payment, value: o.value_form_payment }));

        const summary = {
          total_sales:      total_value_form_payment,
          total_canceled:   total_canceled_notes,
          total_operations: total_value_movement,
          qty_sales:        total_qty_sales,
        };
        const period = { initial: payload.date_initial_close_cashier, finish: payload.date_finish_close_cashier };

        sales_by_payment_method.push({ form_of_payment_id: "", descrition_form_of_payment: "TOTAL", value_form_payment: total_value_form_payment });
        cashier_operation.push({ id: "", type_operation: "TOTAL", value_movement: total_value_movement });

        for (const o of sales_by_payment_method) o.value_form_payment = formatCurrency(o.value_form_payment);
        for (const o of cashier_operation)        o.value_movement     = formatCurrency(o.value_movement);
        for (const o of employee_summary)          o.total_sales_value  = formatCurrency(o.total_sales_value || 0);

        employee_summary.push({ employee_name: "TOTAL", operator_name: "", total_sales_count: total_qty_sales, total_sales_value: formatCurrency(total_employee_sales) });

        if (canceled_notes) {
          for (const o of canceled_notes) o.value_total_note = formatCurrency(o.value_total_note || 0);
          canceled_notes.push({ id: "", client_name: "", number_sale: "TOTAL", data_sale: "", status: "", value_total_note: formatCurrency(total_canceled_notes) });
        }
        if (unfinished_notes) {
          for (const o of unfinished_notes) {
            total_unfinished_notes += o.value_total_note || 0;
            o.value_total_note = formatCurrency(o.value_total_note || 0);
          }
          unfinished_notes.push({ id: "", number_sale: "TOTAL", data_sale: "", status: "", value_total_note: formatCurrency(total_unfinished_notes) });
        }
        if (canceled_items) {
          for (const o of canceled_items) {
            total_canceled_items_value += o.total_value || 0;
            o.unit_value  = formatCurrency(o.unit_value  || 0);
            o.total_value = formatCurrency(o.total_value || 0);
          }
          canceled_items.push({ code_item: "", product_description: "TOTAL", total_amount: "", unit_value: "", total_value: formatCurrency(total_canceled_items_value) });
        }

        const historyRows = this.buildHistoryRows(cashier_operation_history);

        this.createPDF(
          cashier_operation, historyRows, sales_by_payment_method,
          canceled_notes, unfinished_notes, canceled_items, employee_summary,
          arrayenterprise, arrayaddress, period, summary, raw_payment
        );
      } finally {
        this.loading = false;
      }
    },

    buildHistoryRows(rawHistory) {
      const byDate = {};
      for (const op of rawHistory) {
        if (!byDate[op.date_movement]) byDate[op.date_movement] = [];
        byDate[op.date_movement].push(op);
      }
      const rows = [];
      for (const date of Object.keys(byDate).sort()) {
        const ops = byDate[date];
        const isAbertura   = (o) => (o.type_key || o.type_operation || '').toLowerCase().includes('abertura');
        const isFechamento = (o) => (o.type_key || o.type_operation || '').toLowerCase().includes('fechamento');
        const abertura   = ops.find(isAbertura);
        const fechamento = ops.find(isFechamento);
        const details    = ops.filter(o => !isAbertura(o) && !isFechamento(o));
        const isEntrada  = (o) => ['suprimento', 'entrada'].includes((o.type_key || '').toLowerCase());
        const isSaida    = (o) => ['sangria', 'saída', 'saida'].includes((o.type_key || '').toLowerCase());
        const totalSuprimento = details.filter(isEntrada).reduce((s, o) => s + (parseFloat(o.value_movement) || 0), 0);
        const totalSangria    = details.filter(isSaida).reduce((s, o) => s + (parseFloat(o.value_movement) || 0), 0);
        const [y, m, d] = date.split('-');
        rows.push({
          _type:          'summary',
          col_date:       `${d}/${m}/${y}`,
          col_mov:        abertura ? abertura.number_movement : '—',
          col_user:       abertura ? (abertura.operator_name || '—') : '—',
          col_abertura:   formatCurrency(abertura  ? parseFloat(abertura.value_movement)   : 0),
          col_suprimento: formatCurrency(totalSuprimento),
          col_sangria:    formatCurrency(totalSangria),
          col_fechamento: formatCurrency(fechamento ? parseFloat(fechamento.value_movement) : 0),
        });
        for (const op of details) {
          rows.push({
            _type:          'detail',
            col_date:       `   > ${op.type_operation}`,
            col_mov:        op.operation_time,
            col_user:       '',
            col_abertura:   '',
            col_suprimento: isEntrada(op) ? formatCurrency(parseFloat(op.value_movement) || 0) : '',
            col_sangria:    isSaida(op)   ? formatCurrency(parseFloat(op.value_movement) || 0) : '',
            col_fechamento: '',
          });
        }
      }
      return rows;
    },

    createPDF(cashier_operation, historyRows, sales_by_payment_method, canceled_notes, unfinished_notes, canceled_items, employee_summary, enterprise, address, period, summary, raw_payment) {
      const now   = new Date();
      const doc   = new jsPDF("l", "pt", "a4");
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
      const ml = 28, mr = 28;
      const usableW = pageW - ml - mr;

      const C = {
        navy:     [30,  41,  59],
        section:  [51,  65,  85],
        border:   [180, 190, 205],
        rowEven:  [246, 248, 251],
        totalRow: [226, 232, 240],
        cancelRow:[254, 226, 226],
        muted:    [100, 116, 139],
        text:     [30,  41,  59],
        white:    [255, 255, 255],
        green:    [22,  163, 74],
        red:      [220, 38,  38],
        blue:     [37,  99,  235],
        amber:    [180, 120, 10],
        barColors:[[37,99,235],[22,163,74],[220,38,38],[180,120,10],[124,58,237],[6,182,212],[249,115,22],[236,72,153]],
      };

      const tableBase = {
        theme: "grid",
        styles: { fontSize: 7, cellPadding: { top: 2.5, right: 4, bottom: 2.5, left: 4 }, textColor: C.text, lineColor: C.border, lineWidth: 0.25, font: "helvetica" },
        headStyles: { fillColor: C.section, textColor: C.white, fontStyle: "bold", fontSize: 7, cellPadding: { top: 3, right: 4, bottom: 3, left: 4 } },
        alternateRowStyles: { fillColor: C.rowEven },
        margin: { left: ml, right: mr },
      };

      const drawSectionTitle = (title, y) => {
        doc.setFillColor(...C.navy); doc.rect(ml, y, usableW, 13, "F");
        doc.setFont("helvetica", "bold"); doc.setFontSize(7.5); doc.setTextColor(...C.white);
        doc.text(title, ml + 5, y + 9);
        return y + 13;
      };

      const lastRowBold = (tableData) => ({
        didParseCell(d) {
          if (d.row.index === tableData.length - 1 && d.section === "body") {
            d.cell.styles.fontStyle = "bold"; d.cell.styles.fillColor = C.totalRow;
          }
        },
      });

      // CABEÇALHO
      doc.setFillColor(...C.navy); doc.rect(ml, 22, usableW, 22, "F");
      doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(...C.white);
      doc.text("RELATÓRIO DE FECHAMENTO DE CAIXA", pageW / 2, 37, { align: "center" });

      doc.setFillColor(...C.rowEven); doc.setDrawColor(...C.border); doc.setLineWidth(0.3);
      doc.rect(ml, 44, usableW, 20, "FD");
      doc.setFont("helvetica", "normal"); doc.setFontSize(6.5); doc.setTextColor(...C.text);
      doc.text(`CNPJ: ${enterprise[0].cnpj}`, ml + 4, 52);
      doc.text(`Razão Social: ${enterprise[0].name}`, ml + 130, 52);
      doc.text(`Fantasia: ${enterprise[0].fantasyName}`, pageW - mr - 4, 52, { align: "right" });
      doc.text(`${address[0].street}, ${address[0].number} — ${address[0].city}/${address[0].state}   CEP: ${address[0].cep}`, ml + 4, 60);
      doc.setTextColor(...C.muted);
      doc.text(`Emitido por: ${this.userName}  |  ${now.toLocaleString("pt-BR")}`, pageW - mr - 4, 60, { align: "right" });

      doc.setFillColor(...C.navy); doc.rect(ml, 64, usableW, 12, "F");
      doc.setFont("helvetica", "bold"); doc.setFontSize(7); doc.setTextColor(...C.white);
      doc.text(`Período: ${period.initial}  até  ${period.finish}`, pageW / 2, 72, { align: "center" });

      // PAINEL RESUMO
      const boxY = 80, boxH = 26, boxGap = 6, boxW = (usableW - boxGap * 3) / 4;
      const boxes = [
        { label: "TOTAL VENDIDO",      value: formatCurrency(summary.total_sales),      color: C.green },
        { label: "TOTAL CANCELADO",    value: formatCurrency(summary.total_canceled),   color: C.red   },
        { label: "OPERAÇÕES DE CAIXA", value: formatCurrency(summary.total_operations), color: C.blue  },
        { label: "QTD. DE VENDAS",     value: String(summary.qty_sales),                color: C.amber },
      ];
      boxes.forEach((box, i) => {
        const bx = ml + i * (boxW + boxGap);
        doc.setFillColor(...box.color); doc.rect(bx, boxY, boxW, 5, "F");
        doc.setFillColor(...C.rowEven); doc.setDrawColor(...C.border); doc.setLineWidth(0.3);
        doc.rect(bx, boxY + 5, boxW, boxH - 5, "FD");
        doc.setFont("helvetica", "normal"); doc.setFontSize(6); doc.setTextColor(...C.muted);
        doc.text(box.label, bx + boxW / 2, boxY + 12, { align: "center" });
        doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(...box.color);
        doc.text(box.value, bx + boxW / 2, boxY + 22, { align: "center" });
      });

      let curY = boxY + boxH + 8;

      // OPERAÇÕES DE CAIXA
      curY = drawSectionTitle("OPERAÇÕES DE CAIXA", curY);
      doc.autoTable({ ...tableBase, columns: [{ header: "Cód.", dataKey: "id" }, { header: "Tipo da Operação", dataKey: "type_operation" }, { header: "Valor (R$)", dataKey: "value_movement" }], body: cashier_operation, startY: curY, columnStyles: { 0: { cellWidth: 40 }, 2: { cellWidth: 80, halign: "right" } }, ...lastRowBold(cashier_operation) });
      curY = doc.lastAutoTable.finalY + 10;

      // FORMA DE PAGAMENTO
      curY = drawSectionTitle("FORMA DE PAGAMENTO", curY);
      doc.autoTable({ ...tableBase, columns: [{ header: "Descrição", dataKey: "descrition_form_of_payment" }, { header: "Código", dataKey: "form_of_payment_id" }, { header: "Valor (R$)", dataKey: "value_form_payment" }], body: sales_by_payment_method, startY: curY, columnStyles: { 1: { cellWidth: 60 }, 2: { cellWidth: 90, halign: "right" } }, ...lastRowBold(sales_by_payment_method) });
      curY = doc.lastAutoTable.finalY + 8;

      // GRÁFICO DE BARRAS
      const chartItems = raw_payment.filter(p => p.value > 0);
      if (chartItems.length > 0) {
        const maxVal   = Math.max(...chartItems.map(p => p.value));
        const totalVal = chartItems.reduce((s, p) => s + p.value, 0);
        const barAreaW = usableW * 0.55, barH = 6, barGap = 3, labelW = 120;
        const chartH   = chartItems.length * (barH + barGap) + 16;
        doc.setFillColor(...C.rowEven); doc.setDrawColor(...C.border); doc.setLineWidth(0.25);
        doc.rect(ml, curY, usableW, chartH, "FD");
        doc.setFont("helvetica", "bold"); doc.setFontSize(6.5); doc.setTextColor(...C.section);
        doc.text("Distribuição por Forma de Pagamento", ml + 4, curY + 8);
        let barY = curY + 12;
        chartItems.forEach((item, idx) => {
          const color  = C.barColors[idx % C.barColors.length];
          const barLen = maxVal > 0 ? (item.value / maxVal) * barAreaW : 0;
          const bx     = ml + 4 + labelW;
          doc.setFont("helvetica", "normal"); doc.setFontSize(6); doc.setTextColor(...C.text);
          doc.text(item.label.length > 18 ? item.label.substring(0, 17) + "…" : item.label, ml + 4, barY + barH - 1);
          doc.setFillColor(220, 230, 245); doc.rect(bx, barY, barAreaW, barH, "F");
          doc.setFillColor(...color); doc.rect(bx, barY, barLen, barH, "F");
          const pct = totalVal > 0 ? ((item.value / totalVal) * 100).toFixed(1) + "%" : "0%";
          doc.setTextColor(...C.muted);
          doc.text(`${formatCurrency(item.value)}  (${pct})`, bx + barAreaW + 4, barY + barH - 1);
          barY += barH + barGap;
        });
        curY += chartH + 8;
      }

      // HISTÓRICO DE OPERAÇÕES DE CAIXA
      curY = drawSectionTitle("HISTÓRICO DE OPERAÇÕES DE CAIXA", curY);
      doc.autoTable({
        ...tableBase,
        columns: [{ header: "Data / Operação", dataKey: "col_date" }, { header: "Nº Mov / Hora", dataKey: "col_mov" }, { header: "Operador", dataKey: "col_user" }, { header: "Abertura (R$)", dataKey: "col_abertura" }, { header: "Suprimento (R$)", dataKey: "col_suprimento" }, { header: "Sangria (R$)", dataKey: "col_sangria" }, { header: "Fechamento (R$)", dataKey: "col_fechamento" }],
        body: historyRows, startY: curY,
        columnStyles: { 0: { cellWidth: 78 }, 1: { cellWidth: 52 }, 2: { cellWidth: 90 }, 3: { cellWidth: 62, halign: "right" }, 4: { cellWidth: 62, halign: "right" }, 5: { cellWidth: 62, halign: "right" }, 6: { cellWidth: 62, halign: "right" } },
        didParseCell(d) {
          if (d.section !== "body") return;
          if (d.row.raw._type === "summary") { d.cell.styles.fontStyle = "bold"; d.cell.styles.fillColor = C.totalRow; }
          else { d.cell.styles.fontSize = 6; d.cell.styles.textColor = C.muted; d.cell.styles.fillColor = C.white; }
        },
      });
      curY = doc.lastAutoTable.finalY + 10;

      // VENDAS CANCELADAS
      if (canceled_notes != null) {
        curY = drawSectionTitle("VENDAS CANCELADAS", curY);
        doc.autoTable({ ...tableBase, columns: [{ header: "Data", dataKey: "data_sale" }, { header: "Nº da Venda", dataKey: "number_sale" }, { header: "Cliente", dataKey: "client_name" }, { header: "Status", dataKey: "status" }, { header: "Valor (R$)", dataKey: "value_total_note" }], body: canceled_notes, startY: curY, columnStyles: { 0: { cellWidth: 65 }, 1: { cellWidth: 70 }, 3: { cellWidth: 60 }, 4: { cellWidth: 80, halign: "right" } }, didParseCell(d) { if (d.row.index === canceled_notes.length - 1 && d.section === "body") { d.cell.styles.fontStyle = "bold"; d.cell.styles.fillColor = C.cancelRow; } } });
        curY = doc.lastAutoTable.finalY + 10;
      }

      // NOTAS NÃO FINALIZADAS
      if (unfinished_notes != null) {
        curY = drawSectionTitle("NOTAS NÃO FINALIZADAS", curY);
        doc.autoTable({ ...tableBase, columns: [{ header: "Data", dataKey: "data_sale" }, { header: "Nº da Nota", dataKey: "number_sale" }, { header: "Status", dataKey: "status" }, { header: "Valor (R$)", dataKey: "value_total_note" }], body: unfinished_notes, startY: curY, columnStyles: { 0: { cellWidth: 70 }, 1: { cellWidth: 80 }, 2: { cellWidth: 100 }, 3: { cellWidth: 90, halign: "right" } }, didParseCell(d) { if (d.row.index === unfinished_notes.length - 1 && d.section === "body") { d.cell.styles.fontStyle = "bold"; d.cell.styles.fillColor = C.totalRow; } } });
        curY = doc.lastAutoTable.finalY + 10;
      }

      // ITENS CANCELADOS
      if (canceled_items != null) {
        curY = drawSectionTitle("ITENS CANCELADOS", curY);
        doc.autoTable({ ...tableBase, columns: [{ header: "Cód.", dataKey: "code_item" }, { header: "Produto", dataKey: "product_description" }, { header: "Qtd.", dataKey: "total_amount" }, { header: "Vl. Unit. (R$)", dataKey: "unit_value" }, { header: "Vl. Total (R$)", dataKey: "total_value" }], body: canceled_items, startY: curY, columnStyles: { 0: { cellWidth: 45 }, 2: { cellWidth: 45, halign: "right" }, 3: { cellWidth: 80, halign: "right" }, 4: { cellWidth: 80, halign: "right" } }, didParseCell(d) { if (d.row.index === canceled_items.length - 1 && d.section === "body") { d.cell.styles.fontStyle = "bold"; d.cell.styles.fillColor = C.cancelRow; } } });
        curY = doc.lastAutoTable.finalY + 10;
      }

      // RESUMO POR FUNCIONÁRIO
      if (employee_summary != null && employee_summary.length > 0) {
        curY = drawSectionTitle("RESUMO POR FUNCIONÁRIO", curY);
        doc.autoTable({ ...tableBase, columns: [{ header: "Funcionário", dataKey: "employee_name" }, { header: "Operador de Caixa", dataKey: "operator_name" }, { header: "Qtd. Vendas", dataKey: "total_sales_count" }, { header: "Total Vendido (R$)", dataKey: "total_sales_value" }], body: employee_summary, startY: curY, columnStyles: { 2: { cellWidth: 70, halign: "right" }, 3: { cellWidth: 100, halign: "right" } }, ...lastRowBold(employee_summary) });
      }

      // RODAPÉ
      const totalPages = doc.internal.getNumberOfPages();
      for (let p = 1; p <= totalPages; p++) {
        doc.setPage(p);
        doc.setDrawColor(...C.border); doc.setLineWidth(0.4);
        doc.rect(ml - 4, 18, usableW + 8, pageH - 32);
        doc.setLineWidth(0.25); doc.line(ml, pageH - 14, pageW - mr, pageH - 14);
        doc.setFont("helvetica", "normal"); doc.setFontSize(6.5); doc.setTextColor(...C.muted);
        doc.text(`Página ${p} / ${totalPages}`, pageW / 2, pageH - 7, { align: "center" });
      }

      window.open(URL.createObjectURL(doc.output("blob")), "_blank");
    },

    async GetAllNoPage() {
      const value = { page: null, limit: null, paginate: false };
      await this.$store.dispatch(GET_ALL_ENTERPRISE, value);
      await this.$store.dispatch(GET_ALL_CASHIER, value);
    },
  },

  computed: {
    ...mapGetters(["getEnterprises", "getCashier"]),
    ...mapGetters({ userLogin: "auth/userLogin" }),
  },

  created() {
    this.GetAllNoPage();
    this.userName = this.userLogin.user.name;
  },

  watch: {
    getEnterprises(val) {
      if (val.data) {
        this.enterprise = Object.values(val.data);
        this.report.selectEnterprise = this.enterprise[0];
      } else {
        this.enterprise = Object.values(val);
        this.report.selectEnterprise = this.enterprise[0];
      }
    },
    getCashier(val) {
      const allCashiers = val.data ? Object.values(val.data) : Object.values(val);
      const userCashierId = this.userLogin?.user?.cashier_operation?.cashier_id;

      if (!userCashierId) {
        this.noCashierLinked = true;
        this.cashier = [];
        return;
      }

      this.noCashierLinked = false;
      this.cashier = allCashiers.filter(c => c.id === userCashierId);

      if (this.cashier.length === 1) {
        this.report.selectCashier = this.cashier[0].id;
      }
    },
  },
};
</script>
